import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowRight } from 'lucide-react';

const BookingCancelled = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orgBranding, setOrgBranding] = useState({
    name: 'BookingFlows',
    primaryColor: '#007AFF'
  });

  // Extract booking data from URL params
  const orgId = searchParams.get('org');
  const serviceId = searchParams.get('service');
  const date = searchParams.get('date');
  const time = searchParams.get('time');
  const tickets = searchParams.get('tickets');
  const addons = searchParams.get('addons');

  useEffect(() => {
    // Load org info if available
    if (orgId) {
      loadOrgInfo();
    }
  }, [orgId]);

  const loadOrgInfo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/services?org_id=${orgId}`);
      const data = await response.json();
      
      if (data.organization) {
        setOrgBranding({
          name: data.organization.name || 'BookingFlows',
          primaryColor: data.organization.primaryColor || '#007AFF'
        });
      }
    } catch (error) {
      console.error('Error loading org info:', error);
    }
  };

  const handleTryAgain = () => {
    // Build widget URL with all the params they had selected
    let widgetUrl = `/book?org=${orgId}`;
    
    if (serviceId) widgetUrl += `&service=${serviceId}`;
    if (date) widgetUrl += `&date=${date}`;
    if (time) widgetUrl += `&time=${time}`;
    if (tickets) widgetUrl += `&tickets=${tickets}`;
    if (addons) widgetUrl += `&addons=${addons}`;
    
    navigate(widgetUrl);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-2xl">
        <CardContent className="p-8 text-center">
          {/* Icon */}
          <div className="mb-6">
            <div 
              className="w-20 h-20 rounded-full mx-auto flex items-center justify-center"
              style={{ backgroundColor: `${orgBranding.primaryColor}15` }}
            >
              <XCircle 
                className="w-12 h-12" 
                style={{ color: orgBranding.primaryColor }}
              />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Booking Cancelled
          </h1>
          
          <p className="text-gray-600 mb-2">
            No worries! Your booking wasn't completed and you haven't been charged.
          </p>
          
          {serviceId && (
            <p className="text-sm text-gray-500 mb-6">
              Your selections have been saved if you'd like to try again.
            </p>
          )}

          {/* Action Buttons */}
          <div className="mt-8">
            {orgId ? (
              <Button
                onClick={handleTryAgain}
                className="w-full text-lg py-6 text-white font-semibold flex items-center justify-center gap-2"
                style={{ backgroundColor: orgBranding.primaryColor }}
              >
                Try Again
                <ArrowRight className="w-5 h-5" />
              </Button>
            ) : (
              <p className="text-sm text-gray-500">
                You can close this page or use your browser's back button.
              </p>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingCancelled;
